// // src/components/PaymentModal.tsx
// import CloseIcon from "@mui/icons-material/Close";
// import ContentCopyIcon from "@mui/icons-material/ContentCopy";
// import {
//   Box,
//   Button,
//   CircularProgress,
//   Dialog,
//   DialogContent,
//   DialogTitle,
//   Divider,
//   IconButton,
//   Link,
//   List,
//   ListItem,
//   ListItemText,
//   Stack,
//   Tooltip,
//   Typography
// } from "@mui/material";
// import React, { useEffect, useMemo, useState } from "react";
// import { CurrentDebitInterface } from "../common/interfaces";
// import api from "../services/api";
// // Caso prefira, mova a interface para ../../common/interfaces e ajuste os imports.

// type CompanyMinimal = {
//   company_name: string;
//   company_email?: string | null;
//   company_document?: string | null; // CPF/CNPJ como string limpa
//   responsible_name?: string | null; // fallback para nome do pagador
// };

// type PixPaymentResponse = {
//   id: number;
//   status: "pending" | "approved" | "rejected" | string;
//   external_reference: string;
//   payment_method: "pix" | string;
//   pix?: {
//     qr_code: string;
//     qr_code_base64: string;
//     ticket_url: string;
//   };
//   raw?: {
//     status_detail?: string;
//     [k: string]: any;
//   };
// };

// type PaymentModalProps = {
//   open: boolean;
//   onClose: () => void;
//   debits: CurrentDebitInterface[];
// };

// function formatBRL(n: number) {
//   return n.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
// }

// function getCompetenciaFromDueDate(dueISO: string) {
//   const d = new Date(dueISO);
//   const yyyy = d.getFullYear();
//   const mm = String(d.getMonth() + 1).padStart(2, "0");
//   return `${yyyy}-${mm}`;
// }

// function sanitizeDocument(doc?: string | null) {
//   return (doc ?? "").replace(/\D+/g, "");
// }

// export const PaymentModal: React.FC<PaymentModalProps> = ({
//   open,
//   onClose,
//   debits
// }) => {
//   const [loadingCompany, setLoadingCompany] = useState(false);
//   const [company, setCompany] = useState<CompanyMinimal | null>(null);

//   const [creatingId, setCreatingId] = useState<number | null>(null); // subscription_id em processamento
//   const [error, setError] = useState<string | null>(null);

//   // Resposta por débito (subscription_id -> pagamento PIX)
//   const [payments, setPayments] = useState<Record<number, PixPaymentResponse>>(
//     {}
//   );

//   // Carrega dados mínimos do pagador (empresa) ao abrir
//   useEffect(() => {
//     if (!open) return;
//     (async () => {
//       try {
//         setLoadingCompany(true);
//         setError(null);
//         // Ajuste se seu endpoint for diferente:
//         const { data } = await api.get<CompanyMinimal>("/company/my-company");
//         setCompany({
//           company_name: data.company_name,
//           company_email: data.company_email ?? null,
//           company_document: sanitizeDocument(data.company_document),
//           responsible_name: data.responsible_name ?? data.company_name
//         });
//       } catch (e) {
//         console.error(e);
//         setError("Não foi possível carregar os dados do pagador.");
//       } finally {
//         setLoadingCompany(false);
//       }
//     })();
//   }, [open]);

//   const debitsSorted = useMemo(() => {
//     // ordena por due_date desc (mais urgente primeiro)
//     return [...debits].sort(
//       (a, b) => new Date(a.due_date).getTime() - new Date(b.due_date).getTime()
//     );
//   }, [debits]);

//   async function handlePayPix(d: CurrentDebitInterface) {
//     try {
//       setError(null);
//       setCreatingId(d.subscription_id);

//       // valor a pagar (restante): charged - paid
//       const remaining =
//         Math.max(0, (d.charged_amount ?? 0) - (d.paid_amount ?? 0)) || 0;

//       if (remaining <= 0) {
//         setError("Este débito já está quitado.");
//         setCreatingId(null);
//         return;
//       }

//       const competencia = getCompetenciaFromDueDate(d.due_date);
//       const payer_name =
//         company?.responsible_name || company?.company_name || "Cliente";
//       const payer_email = company?.company_email || "cliente@exemplo.com";
//       const payer_cpf = company?.company_document || "00000000000";

//       // Você pode ajustar essa data de expiração como preferir (ex.: +2 dias às 23:59).
//       const exp = new Date();
//       exp.setDate(exp.getDate() + 2);
//       exp.setHours(23, 59, 59, 0);
//       const expiration_date = exp.toISOString();

//       // Monte o body EXATAMENTE como seu backend espera
//       const body = {
//         transaction_amount: remaining,
//         description: `Mensalidade ${competencia}`,
//         payment_method: "pix",
//         external_reference: `cust:${d.company_id}|sub:${d.subscription_id}|competencia:${competencia}`,
//         payer_email,
//         payer_first_name: payer_name,
//         payer_cpf,
//         expiration_date
//       };

//       const { data } = await api.post<PixPaymentResponse>("/payment", body);

//       setPayments((prev) => ({
//         ...prev,
//         [d.subscription_id]: data
//       }));
//     } catch (e: any) {
//       console.error(e);
//       const msg =
//         e?.response?.data?.message ||
//         e?.message ||
//         "Falha ao gerar pagamento PIX.";
//       setError(msg);
//     } finally {
//       setCreatingId(null);
//     }
//   }

//   function copyToClipboard(text: string) {
//     navigator.clipboard
//       .writeText(text)
//       .then(() => {
//         // opcional: feedback visual
//       })
//       .catch(() => {
//         // ignore
//       });
//   }

//   return (
//     <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
//       <DialogTitle sx={{ pr: 6 }}>
//         <Typography variant="h6" fontWeight={700}>
//           Débitos em aberto
//         </Typography>
//         <IconButton
//           size="small"
//           onClick={onClose}
//           sx={{ position: "absolute", right: 8, top: 8 }}
//         >
//           <CloseIcon />
//         </IconButton>
//       </DialogTitle>

//       <DialogContent dividers>
//         {loadingCompany && (
//           <Stack direction="row" alignItems="center" gap={1} sx={{ mb: 2 }}>
//             <CircularProgress size={18} />{" "}
//             <Typography variant="body2">
//               Carregando dados do pagador…
//             </Typography>
//           </Stack>
//         )}

//         {error && (
//           <Typography color="error" sx={{ mb: 2 }}>
//             {error}
//           </Typography>
//         )}

//         {debitsSorted.length === 0 ? (
//           <Typography variant="body2">
//             Nenhum débito pendente para exibir.
//           </Typography>
//         ) : (
//           <List dense>
//             {debitsSorted.map((d, idx) => {
//               const remaining =
//                 Math.max(0, (d.charged_amount ?? 0) - (d.paid_amount ?? 0)) ||
//                 0;
//               const comp = getCompetenciaFromDueDate(d.due_date);
//               const pay = payments[d.subscription_id];
//               const paying = creatingId === d.subscription_id;

//               return (
//                 <Box key={`${d.subscription_id}-${idx}`} sx={{ mb: 2 }}>
//                   <ListItem
//                     disableGutters
//                     secondaryAction={
//                       <Stack direction="row" alignItems="center" gap={1}>
//                         <Button
//                           variant="contained"
//                           size="small"
//                           disabled={paying || remaining <= 0}
//                           onClick={() => handlePayPix(d)}
//                           sx={{
//                             textTransform: "none",
//                             fontWeight: 700,
//                             backgroundColor: "#fddb00",
//                             color: "#000",
//                             "&:hover": { backgroundColor: "#e6c200" },
//                             minWidth: 120
//                           }}
//                         >
//                           {paying ? (
//                             <Stack direction="row" gap={1} alignItems="center">
//                               <CircularProgress size={16} />
//                               <span>Gerando…</span>
//                             </Stack>
//                           ) : remaining > 0 ? (
//                             `Pagar (${formatBRL(remaining)})`
//                           ) : (
//                             "Quitado"
//                           )}
//                         </Button>
//                       </Stack>
//                     }
//                   >
//                     <ListItemText
//                       primary={
//                         <Stack direction="row" gap={1} flexWrap="wrap">
//                           <Typography fontWeight={700}>
//                             Competência: {comp}
//                           </Typography>
//                           <Typography color="text.secondary">
//                             Venc.:{" "}
//                             {new Date(d.due_date).toLocaleDateString("pt-BR")}
//                           </Typography>
//                         </Stack>
//                       }
//                       secondary={
//                         <Stack direction="row" gap={2} flexWrap="wrap">
//                           <span>Total: {formatBRL(d.charged_amount)}</span>
//                           <span>Pago: {formatBRL(d.paid_amount)}</span>
//                           <span>
//                             Em aberto: <b>{formatBRL(remaining)}</b>
//                           </span>
//                         </Stack>
//                       }
//                     />
//                   </ListItem>

//                   {/* Caso já exista pagamento gerado, mostra QRCode/linK */}
//                   {pay?.pix && (
//                     <Box
//                       sx={{
//                         mt: 1.5,
//                         p: 1.5,
//                         border: "1px solid #eee",
//                         borderRadius: 1
//                       }}
//                     >
//                       <Typography
//                         variant="subtitle2"
//                         fontWeight={700}
//                         sx={{ mb: 1 }}
//                       >
//                         PIX • Escaneie o QR Code ou copie o código
//                       </Typography>
//                       <Stack
//                         direction={{ xs: "column", sm: "row" }}
//                         gap={2}
//                         alignItems="center"
//                       >
//                         <Box
//                           component="img"
//                           alt="QR Code PIX"
//                           src={`data:image/png;base64,${pay.pix.qr_code_base64}`}
//                           sx={{ width: 180, height: 180, objectFit: "contain" }}
//                         />

//                         <Stack flex={1} gap={1}>
//                           <Typography
//                             variant="body2"
//                             sx={{
//                               p: 1,
//                               bgcolor: "#fafafa",
//                               border: "1px dashed #ddd",
//                               borderRadius: 1,
//                               maxHeight: 96,
//                               overflow: "auto",
//                               wordBreak: "break-all",
//                               fontFamily: "monospace"
//                             }}
//                           >
//                             {pay.pix.qr_code}
//                           </Typography>

//                           <Stack direction="row" gap={1}>
//                             <Tooltip title="Copiar código PIX">
//                               <Button
//                                 variant="outlined"
//                                 size="small"
//                                 startIcon={<ContentCopyIcon fontSize="small" />}
//                                 onClick={() =>
//                                   copyToClipboard(pay.pix!.qr_code)
//                                 }
//                                 sx={{ textTransform: "none" }}
//                               >
//                                 Copiar código
//                               </Button>
//                             </Tooltip>

//                             <Button
//                               variant="contained"
//                               size="small"
//                               component={Link}
//                               href={pay.pix.ticket_url}
//                               target="_blank"
//                               rel="noopener"
//                               sx={{
//                                 textTransform: "none",
//                                 fontWeight: 700,
//                                 backgroundColor: "#fddb00",
//                                 color: "#000",
//                                 "&:hover": { backgroundColor: "#e6c200" }
//                               }}
//                             >
//                               Abrir no Mercado Pago
//                             </Button>
//                           </Stack>

//                           {pay.raw?.status_detail && (
//                             <Typography
//                               variant="caption"
//                               color="text.secondary"
//                             >
//                               status_detail: {pay.raw.status_detail}
//                             </Typography>
//                           )}
//                         </Stack>
//                       </Stack>
//                     </Box>
//                   )}

//                   <Divider sx={{ mt: 2 }} />
//                 </Box>
//               );
//             })}
//           </List>
//         )}
//       </DialogContent>
//     </Dialog>
//   );
// };

// src/components/PaymentModal.tsx
import CloseIcon from "@mui/icons-material/Close";
import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
  List,
  ListItem,
  ListItemText,
  Stack,
  Typography
} from "@mui/material";
import React, { useEffect, useMemo, useState } from "react";
import api from "../services/api";

// Tipagem local (evita dependência cíclica com VerseSidebar)
type CurrentDebitInterface = {
  charged_amount: number;
  company_id: number;
  config_id: number;
  created_at: string;
  due_date: string;
  is_in_debt: number; // 0 | 1
  paid_amount: number;
  payment_date: string | null;
  subscription_id: number;
  updated_at: string;
};

type CompanyMinimal = {
  company_name: string;
  company_email?: string | null;
  company_document?: string | null; // CPF/CNPJ
  responsible_name?: string | null; // fallback para nome do pagador
};

type PixPaymentResponse = {
  id: number;
  status: "pending" | "approved" | "rejected" | string;
  external_reference: string;
  payment_method: "pix" | string;
  pix?: {
    qr_code: string;
    qr_code_base64: string;
    ticket_url: string;
  };
  raw?: {
    status_detail?: string;
    [k: string]: any;
  };
};

type PaymentModalProps = {
  open: boolean;
  onClose: () => void;
  debits: CurrentDebitInterface[];
};

function formatBRL(n: number) {
  return n.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
}

function getCompetenciaFromDueDate(dueISO: string) {
  const d = new Date(dueISO);
  const yyyy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  return `${yyyy}-${mm}`;
}

function sanitizeDocument(doc?: string | null) {
  return (doc ?? "").replace(/\D+/g, "");
}

export const PaymentModal: React.FC<PaymentModalProps> = ({
  open,
  onClose,
  debits
}) => {
  const [loadingCompany, setLoadingCompany] = useState(false);
  const [company, setCompany] = useState<CompanyMinimal | null>(null);

  const [creatingId, setCreatingId] = useState<number | null>(null); // subscription_id em processamento
  const [error, setError] = useState<string | null>(null);

  // Resposta por débito (subscription_id -> pagamento PIX)
  const [payments, setPayments] = useState<Record<number, PixPaymentResponse>>(
    {}
  );

  // Carrega dados mínimos do pagador ao abrir
  useEffect(() => {
    if (!open) return;
    (async () => {
      try {
        setLoadingCompany(true);
        setError(null);
        const { data } = await api.get<CompanyMinimal>("/company/my-company");
        setCompany({
          company_name: data.company_name,
          company_email: data.company_email ?? null,
          company_document: sanitizeDocument(data.company_document),
          responsible_name: data.responsible_name ?? data.company_name
        });
      } catch (e) {
        console.error(e);
        setError("Não foi possível carregar os dados do pagador.");
      } finally {
        setLoadingCompany(false);
      }
    })();
  }, [open]);

  const debitsSorted = useMemo(() => {
    return [...debits].sort(
      (a, b) => new Date(a.due_date).getTime() - new Date(b.due_date).getTime()
    );
  }, [debits]);

  async function handlePayPix(d: CurrentDebitInterface) {
    try {
      setError(null);
      setCreatingId(d.subscription_id);

      const remaining =
        Math.max(0, (d.charged_amount ?? 0) - (d.paid_amount ?? 0)) || 0;

      if (remaining <= 0) {
        setError("Este débito já está quitado.");
        setCreatingId(null);
        return;
      }

      const competencia = getCompetenciaFromDueDate(d.due_date);
      const payer_name =
        company?.responsible_name || company?.company_name || "Cliente";
      const payer_email = company?.company_email || "cliente@exemplo.com";
      const payer_cpf = company?.company_document || "00000000000";

      const exp = new Date();
      exp.setDate(exp.getDate() + 2);
      exp.setHours(23, 59, 59, 0);
      const expiration_date = exp.toISOString();

      const body = {
        transaction_amount: remaining,
        description: `Mensalidade ${competencia}`,
        payment_method: "pix",
        external_reference: `cust:${d.company_id}|sub:${d.subscription_id}|competencia:${competencia}`,
        payer_email,
        payer_first_name: payer_name,
        payer_cpf,
        expiration_date
      };

      const { data } = await api.post<PixPaymentResponse>("/payment", body);

      setPayments((prev) => ({
        ...prev,
        [d.subscription_id]: data
      }));
    } catch (e: any) {
      console.error(e);
      const msg =
        e?.response?.data?.message ||
        e?.message ||
        "Falha ao gerar pagamento PIX.";
      setError(msg);
    } finally {
      setCreatingId(null);
    }
  }

  // Ao clicar em "Abrir no Mercado Pago": abre em nova aba e fecha o modal
  function openMercadoPagoAndClose(url: string) {
    try {
      window.open(url, "_blank", "noopener,noreferrer");
    } finally {
      onClose();
    }
  }

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle sx={{ pr: 6 }}>
        <Typography variant="h6" fontWeight={700}>
          Débitos em aberto
        </Typography>
        <IconButton
          size="small"
          onClick={onClose}
          sx={{ position: "absolute", right: 8, top: 8 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers>
        {loadingCompany && (
          <Stack direction="row" alignItems="center" gap={1} sx={{ mb: 2 }}>
            <CircularProgress size={18} />{" "}
            <Typography variant="body2">
              Carregando dados do pagador…
            </Typography>
          </Stack>
        )}

        {error && (
          <Typography color="error" sx={{ mb: 2 }}>
            {error}
          </Typography>
        )}

        {debitsSorted.length === 0 ? (
          <Typography variant="body2">
            Nenhum débito pendente para exibir.
          </Typography>
        ) : (
          <List dense>
            {debitsSorted.map((d, idx) => {
              const remaining =
                Math.max(0, (d.charged_amount ?? 0) - (d.paid_amount ?? 0)) ||
                0;
              const comp = getCompetenciaFromDueDate(d.due_date);
              const pay = payments[d.subscription_id];
              const paying = creatingId === d.subscription_id;

              return (
                <Box key={`${d.subscription_id}-${idx}`} sx={{ mb: 2 }}>
                  <ListItem
                    disableGutters
                    secondaryAction={
                      <Stack direction="row" alignItems="center" gap={1}>
                        {!pay ? (
                          <Button
                            variant="contained"
                            size="small"
                            disabled={paying || remaining <= 0}
                            onClick={() => handlePayPix(d)}
                            sx={{
                              textTransform: "none",
                              fontWeight: 700,
                              backgroundColor: "#fddb00",
                              color: "#000",
                              "&:hover": { backgroundColor: "#e6c200" },
                              minWidth: 140
                            }}
                          >
                            {paying ? (
                              <Stack
                                direction="row"
                                gap={1}
                                alignItems="center"
                              >
                                <CircularProgress size={16} />
                                <span>Gerando…</span>
                              </Stack>
                            ) : remaining > 0 ? (
                              `Pagar (${formatBRL(remaining)})`
                            ) : (
                              "Quitado"
                            )}
                          </Button>
                        ) : (
                          <Button
                            variant="contained"
                            size="small"
                            onClick={() =>
                              openMercadoPagoAndClose(pay.pix!.ticket_url)
                            }
                            sx={{
                              textTransform: "none",
                              fontWeight: 700,
                              backgroundColor: "#fddb00",
                              color: "#000",
                              "&:hover": { backgroundColor: "#e6c200" },
                              minWidth: 220
                            }}
                          >
                            Abrir no Mercado Pago
                          </Button>
                        )}
                      </Stack>
                    }
                  >
                    <ListItemText
                      primary={
                        <Stack direction="row" gap={1} flexWrap="wrap">
                          <Typography fontWeight={700}>
                            Competência: {comp}
                          </Typography>
                          <Typography color="text.secondary">
                            Venc.:{" "}
                            {new Date(d.due_date).toLocaleDateString("pt-BR")}
                          </Typography>
                        </Stack>
                      }
                      secondary={
                        <Stack direction="row" gap={2} flexWrap="wrap">
                          <span>Total: {formatBRL(d.charged_amount)}</span>
                          <span>Pago: {formatBRL(d.paid_amount)}</span>
                          <span>
                            Em aberto:{" "}
                            <b>
                              {formatBRL(
                                Math.max(0, d.charged_amount - d.paid_amount)
                              )}
                            </b>
                          </span>
                        </Stack>
                      }
                    />
                  </ListItem>

                  {/* ANTES: Mostrava QRCode/código PIX aqui.
                      AGORA: ocultado por sua decisão. Apenas o link. */}

                  {/* Informação adicional opcional */}
                  {pay?.raw?.status_detail && (
                    <Typography
                      variant="caption"
                      color="text.secondary"
                      sx={{ ml: 2 }}
                    >
                      status_detail: {pay.raw.status_detail}
                    </Typography>
                  )}

                  <Divider sx={{ mt: 2 }} />
                </Box>
              );
            })}
          </List>
        )}
      </DialogContent>
    </Dialog>
  );
};
